import { Component, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { CommonService, Shared } from '@rubii/frontend-common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../../services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { ClientService } from '../../../services/client.service';

@Component({
  selector: 'app-outbrain',
  templateUrl: './outbrain.component.html',
  styleUrls: ['./outbrain.component.scss']
})
export class OutbrainComponent extends BaseDatasourceComponent implements OnInit {


  constructor(private client: ClientService, private config: ConfigService, private snackBar: MatSnackBar, private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  ngOnInit() {
    this.connectionForm = new FormGroup({
      clientId: new FormControl('', [Validators.required]),
      clientSecret: new FormControl('', [Validators.required]),
    });
  }

  connect() {
    if (this.connectionForm.valid) {      
      this.client.account.saveOutbrainConfig(this.connectionForm.value).then(result => {
        this.openSnackBar(this.snackBar, 'Data source connected.', 'closed');
          this.dialogRef.close();
      }).catch(e => this.openSnackBarWarning(this.snackBar, e.message, 'closed'));
    }
  }
}
